import { render, staticRenderFns } from "./MatchInfoTable.vue?vue&type=template&id=2e269f3e&scoped=true"
import script from "./MatchInfoTable.vue?vue&type=script&lang=js"
export * from "./MatchInfoTable.vue?vue&type=script&lang=js"
import style0 from "./MatchInfoTable.vue?vue&type=style&index=0&id=2e269f3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e269f3e",
  null
  
)

export default component.exports